import { useEffect, useState } from 'react'

// ///////////////////////
// MARK: FUNCTIONS
const isContentScrollable = (
  ref: Element,
  dir: 'horizontal' | 'vertical',
  threshold: number,
): boolean =>
  dir === 'horizontal' ? ref.scrollWidth > ref.clientWidth : ref.scrollHeight > ref.clientHeight

// ///////////////////////
// MARK: EXPORTS
export function useScrollable(
  ref: HTMLElement = document.body.parentElement!,
  dir: 'horizontal' | 'vertical' = 'vertical',
  threshold = 0,
): boolean {
  const [scrollable, setScrollable] = useState<boolean>(false)

  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      const entry = entries[0]

      setScrollable(isContentScrollable(entry.target, dir, threshold))
    })

    observer.observe(ref)

    return () => {
      observer.unobserve(ref)
      observer.disconnect()
    }
  }, [ref, dir, threshold])

  return scrollable
}
